import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-caste',
  templateUrl: './caste.component.html',
  styleUrls: ['./caste.component.css']
})
export class CasteComponent implements OnInit {
  myForm: FormGroup;
  table: Array<any> = [];
  isEdit: boolean = false;
  labelName: any = {};
  headingName: any = {};
  workItemId: any;
  editData: any;
  casteId: any;
  constructor(private toastr: ToastrService, private active: ActivatedRoute, private fb: FormBuilder, private CommonService: CommonService) {
    this.active.params.subscribe(res => {
      this.workItemId = res.id
    })
    this.loadCaste();
    this.loadlabels();
    this.loadHeadings();
  }

  ngOnInit(): void {
    this.myForm = this.fb.group({
      caste_name: ['',Validators.required],
      caste_description: ['',Validators.required],
      status: ['',Validators.required]
    })
  }


  loadlabels() {
    this.labelName = {};
    this.CommonService.getCall(`TenantRegistration/GetLabelValuesByTaskid/${this.workItemId}/${localStorage.getItem('TenantCode')}`).subscribe((res: any) => {
      this.labelName = res;
      console.log(res);
    })
  }

  loadHeadings() {
    this.headingName = {};
    this.CommonService.getCall(`EmsDynamicheadingLables/GetLabelValuesByTaskid/${this.workItemId}/${localStorage.getItem('TenantCode')}`).subscribe((res: any) => {
      this.headingName = res;
    })
  }

  loadCaste() {
    this.table = [];
    let payLoad = {
      "tnt_code": localStorage.getItem('TenantCode')
    }
    this.CommonService.postCall('EmsCaste/GetList', payLoad).subscribe((res: any) => {
      this.table = res;
    })
  }
  onSubmit(form: any) {
    let value: any = form.value;
    value['tnt_code'] = localStorage.getItem('TenantCode');
    value['created_by'] = localStorage.getItem('UserId');
    value['modified_by'] = localStorage.getItem('UserId');
    if (this.isEdit) {
      value['modified_by'] = localStorage.getItem('UserId');
      value['caste_id'] = this.casteId;
      this.CommonService.postCall('EmsCaste/Update', value).subscribe((res: any) => {
        this.loadCaste();
        this.toastr.success("Bus Number Updated Successfully");
        document.getElementById('md_close').click();
      }, err => {
        this.toastr.error(err.error ? err.error : 'Bus Number Not Updated')
      })
    } else {
      this.CommonService.postCall('EmsCaste/Create', value).subscribe((res: any) => {
        this.loadCaste();
        this.toastr.success("Caste Created Successfully");
        document.getElementById('md_close').click();
      }, err => {
        this.toastr.error(err.error ? err.error : 'Caste Not created')
      })

    }
  }



  add() {
    this.editData = {};
    this.isEdit = false;
    this.myForm.reset();
  }


  edit(cId: any) {
    this.casteId = cId;
    console.log(cId);
    this.isEdit = true;
    let payLoad = {
      "caste_id": cId
    }
    this.CommonService.postCall('EmsCaste/Get', payLoad).subscribe((res: any) => {
      this.editData = res;
      setTimeout(() => {
        this.dataTransfer(res);
      }, 10);
    })
  }

  dataTransfer(data) {
    this.myForm.patchValue({
      caste_name: data['caste_name'],
      caste_description: data['caste_description'],
      status: data['status'],
    })
  }
  close() {

  }
}
